import api from '../../plugins/api';

const editRoles = (params) => {
  return api.post('/api/roles/edit', params);
};

export default editRoles;
